module.exports = __webpack_public_path__ + "static/media/marker.f1d8d841.svg";